<div class="container-fluid">
    <app-breadcrumb
        [title]="'Suivi des opérations'"
        [active_item]="'Suivi & Traitement'"
    ></app-breadcrumb>
    <div class="card" [ngStyle]="{ 'border-radius': '10px' }">
        <div class="card-body">
            <div style="margin-top: -2rem !important">
                <app-patrimoine-header
                    [displayDate]="false"
                    [count]="listTraitemants"
                    [total]="totalRecords"
                    [legendePluriel]="'dossiers en traitement'"
                    [legendeSingulier]="'dossier en traitement'"
                >
                </app-patrimoine-header>
            </div>
            <div class="row filter_wrapper">
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Type opération</b></label>
                        <p-dropdown
                            [options]="listOperations"
                            [showClear]="true"
                            [(ngModel)]="selectedTypeOperation"
                            placeholder="Opération"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>N° Dossier</b>
                        </label>
                        <input
                            placeholder="Demande"
                            [(ngModel)]="selectedTransaction"
                            type="text"
                            pInputText
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Etape</b> </label>
                        <p-dropdown
                            [options]="listStatutTransactions"
                            (onChange)="OnChangeStatut($event)"
                            [showClear]="true"
                            [(ngModel)]="selectedStatut"
                            placeholder="Statut"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Traitement</b> </label>
                        <p-dropdown
                            [options]="listTraitementTransactions"
                            [filter]="true"
                            filterBy="libele"
                            [showClear]="true"
                            [(ngModel)]="selectedTraitement"
                            placeholder="Traitement"
                            name="libele"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Demandeur</b></label>
                    <p-dropdown
                        [options]="listUsers"
                        [(ngModel)]="currentUser"
                        optionLabel="fullName"
                        [filter]="true"
                        filterBy="fullName"
                        [showClear]="true"
                        placeholder="demandeur"
                    >
                        <ng-template let-data pTemplate="item">
                            <div class="country-item">
                                <div>{{ data.fullName }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div
                    class="p-0"
                    [ngStyle]="{ width: '4rem' }"
                    *ngIf="!secondFilter"
                >
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                    ></p-button>
                </div>
                <div class="p-0" [ngStyle]="{ width: '4rem' }">
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        *ngIf="!secondFilter"
                        (click)="showSecondFilter()"
                        styleClass="p-button-dark"
                        icon="pi pi-plus"
                    ></p-button>
                    <p-button
                        *ngIf="secondFilter"
                        (click)="showSecondFilter()"
                        styleClass="p-button-dark"
                        icon="pi pi-minus"
                    ></p-button>
                </div>
            </div>
            <!--------------------Second-------------Filter--------->
            <div
                class="row filter_wrapper"
                style="padding-top: 0.7rem"
                *ngIf="secondFilter"
            >
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>MSISDN</b>
                        </label>
                        <input
                            placeholder="Numéro"
                            [(ngModel)]="selectedSim"
                            type="text"
                            pInputText
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>IMSI</b>
                        </label>
                        <input
                            placeholder="IMSI"
                            [(ngModel)]="selectedimsi"
                            type="text"
                            pInputText
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Date début</b></label>
                    <p-calendar
                        [(ngModel)]="filterDateStart"
                        [showIcon]="true"
                        (ngModelChange)="changeDateStart($event)"
                        dateFormat="dd-mm-yy"
                        [showButtonBar]="true"
                    ></p-calendar>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Date fin </b></label>
                    <p-calendar
                        [(ngModel)]="filterDateEnd"
                        [showIcon]="true"
                        [showClear]="true"
                        (ngModelChange)="changeDateEnd($event)"
                        dateFormat="dd-mm-yy"
                        [showButtonBar]="true"
                    ></p-calendar>
                </div>
                <div class="p-0" [ngStyle]="{ width: '4rem' }">
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                    ></p-button>
                </div>
            </div>
            <hr />
            <div class="table_content_wrapper">
                <div class="table_actions_wrapper pt-2">
                    <button
                        pButton
                        pRipple
                        label="Rafraîchir"
                        (click)="OnRefresh()"
                        icon="pi pi-refresh"
                        class="p-button-secondary"
                    ></button>
                    <button
                        pButton
                        pRipple
                        label="Exporter"
                        (click)="OnExportExcel()"
                        icon="pi pi-download"
                        [disabled]="disableAction()"
                        class="p-button-helf"
                    ></button>
                </div>
                <div class="d-flex gap-3">
                    <div class="table_header__legende">
                        <app-table-header
                            [count]="listTraitemants"
                            [legende]="'derniers traitements'"
                            [page]="page"
                            [totalPage]="totalPage"
                        ></app-table-header>
                    </div>
                </div>
                <table [ngClass]="['native_table table']">
                    <thead>
                        <th class="text-center" [style]="{ width: '2rem' }">
                            #
                        </th>
                        <th [style]="{ width: '10rem' }">Date Demande</th>
                        <th class="text-center" [style]="{ width: '14rem' }">
                            N° Dossier
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            # Lignes
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            # Traitées
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            Etape
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            Etat
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            Date traitement
                        </th>
                        <th class="text-center" [style]="{ width: '4rem' }">
                            Demandeur
                        </th>
                        <th class="text-center" [style]="{ width: '3rem' }">
                            Actions
                        </th>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="
                                let data of listTraitemants
                                    | paginate
                                        : {
                                              itemsPerPage: recordsPerPage,
                                              currentPage: p,
                                              totalPages: totalPage,
                                              totalItems: totalRecords
                                          };
                                let i = index
                            "
                        >
                            <td>{{ this.offset + i }}</td>
                            <td style="text-align: left">
                                {{ data?.created_at }}
                            </td>
                            <td
                                (click)="copyData(data.numero_demande)"
                                style="cursor: pointer"
                            >
                                {{ data?.numero_demande }}
                            </td>
                            <td>{{ data?.nb_demande_soumises ?? 'N/A' }}</td>
                            <td>{{ data?.nb_demande_traitees ?? 'N/A' }}</td>
                            <td class="text-center" [style]="{ width: '3rem' }">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    [class]="'badge ' + getEtapeBadge(data)"
                                >
                                    {{
                                        data?.statut === 'traiter'
                                            ? 'Complet'
                                            : data?.statut
                                    }}
                                </span>
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    [class]="'badge ' + getEtatBadge(data)"
                                >
                                    {{
                                        data.traitement === BADGE_ETAT.COMPLET
                                            ? 'complet'
                                            : data.traitement
                                    }}
                                </span>
                            </td>
                            <td class="text-center">
                                <!-- {{ getDateTraitement(data) }} -->
                                {{ data?.updated_at }}
                            </td>
                            <td class="text-center">
                                {{ data?.demandeur_nom }}
                                {{ data?.demandeur_prenoms }}
                            </td>
                            <td class="td-actions">
                                <button
                                    pButton
                                    pRipple
                                    icon="pi pi-folder-open"
                                    [pTooltip]="
                                        !data?.nb_demande_traitees ? '' : 'Voir'
                                    "
                                    class="p-button-dark"
                                    tooltipPosition="top"
                                    [disabled]="
                                        !data?.nb_demande_traitees ||
                                        (data.statut ===
                                            BADGE_ETAPE.TRAITEMENT &&
                                            data.traitement ===
                                                BADGE_ETAT.TERMINE)
                                    "
                                    (click)="OnShowTraitement(data, 'details')"
                                ></button>
                                <!-- <button
                                    pButton
                                    icon="pi pi-sync"
                                    [pTooltip]="
                                        data?.traitement !== treatmenAccepter
                                            ? ''
                                            : 'Traiter'
                                    "
                                    tooltipPosition="top"
                                    (click)="
                                        OnShowModalTraitement(data, 'traiter')
                                    "
                                    [disabled]="
                                        data?.traitement !== treatmenAccepter
                                    "
                                    class="p-button-secondary"
                                ></button> -->
                                <button
                                    pButton
                                    tooltipPosition="top"
                                    (click)="OnShowModalTraitement(data)"
                                    [ngClass]="
                                        getStyleButtonTraitement(data).class
                                    "
                                    [icon]="getStyleButtonTraitement(data).icon"
                                    [pTooltip]="
                                        getStyleButtonTraitement(data).tooltip
                                    "
                                ></button>
                                <button
                                    pButton
                                    icon="pi pi-book"
                                    pTooltip="Journal"
                                    tooltipPosition="top"
                                    (click)="showJournal(data)"
                                    class="p-button-primary"
                                ></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div [ngClass]="['pagination-controls']">
                    <pagination-controls
                        (pageChange)="onPageChange($event)"
                        previousLabel=""
                        nextLabel=""
                    >
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="progress-spinner" *ngIf="IsLoading">
    <p-progressSpinner
        [style]="{ width: '70px', height: '70px' }"
        strokeWidth="5"
        styleClass="spinner"
    ></p-progressSpinner>
</div>
